import aa from 'search-insights';
import algoliasearch from 'algoliasearch/lite';



// Product Clicked: Triggered when a user clicks on a listing in the search results.
export const clickedObjectIDsMethodName = "clickedObjectIDs";
export const PRODUCT_CLICKED_EVENT = "Product Clicked"


// A user selected a facet value.
export const clickedFiltersMethodName = "clickedFilters";
export const FILTER_CLICKED_EVENT = "PLP: Filter Clicked";

// Product Added to Cart
export const addedToCartObjectIDsMethodName = "addedToCartObjectIDs";
export const PRODUCT_ADDED_TO_CART_EVENT="Product Added to Cart"

// Purchase Completed: purchasedObjectIDs
export const purchasedObjectIDsMethodName = "purchasedObjectIDs";
export const PURCHASE_COMPLETED_EVENT="Purchase Completed";



export const algoliaEventTrackFn = async (method, data) => {
  try {
    const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
    const REACT_APP_ALGOLIA_SEARCH_API_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;

    // load script for algolia events
    await aa('init', {
      appId: ALGOLIA_APP_ID,
      apiKey: REACT_APP_ALGOLIA_SEARCH_API_KEY,
    });

    return aa(method, data)
      .then((response) => console.log(response, '&&&  algoliaEventTrackFn &&& => response'))
      .catch(e => console.log(e, '&&& &&& => e')
      )
  } catch (e) {
    console.log(e, '&&& algoliaEventTrackFn &&& => e');
  }
};

export const algoliaEventSearchQuery = async (query, currentUser) => {
  try {
    const userID = currentUser?.id?.uuid;
    if (userID) {
      const { REACT_APP_ALGOLIA_LISTING_INDEX, REACT_APP_ALGOLIA_APP_ID, REACT_APP_ALGOLIA_SEARCH_API_KEY } = process.env;
      const searchClient = await algoliasearch(
        REACT_APP_ALGOLIA_APP_ID,
        REACT_APP_ALGOLIA_SEARCH_API_KEY
      );
      const searchClientIndex = await searchClient.initIndex(REACT_APP_ALGOLIA_LISTING_INDEX);
      const { nbHits } = await searchClientIndex.search(query);

      // Handle Search Query Submitted Event
      algoliaEventTrackFn("sendEvent", {
        index: REACT_APP_ALGOLIA_LISTING_INDEX,
        eventName: "querySubmitted",
        userToken: userID,
        eventData: {
          userID,
          query: query,
          timestamp: new Date().toISOString(),
        },
      });
    }

  } catch (error) {
    console.log(error, '&&& &&& => error');
  }
}
